import { IonButton, IonButtons, IonContent, IonDatetime, IonDatetimeButton, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonModal, IonSelect, IonSelectOption, IonTitle, IonToolbar } from '@ionic/react';
import { Form, Formik } from 'formik';
import { checkmarkDoneOutline, optionsOutline, squareOutline } from 'ionicons/icons';
import React, { useContext, useEffect, useRef, useState } from 'react';
import * as Yup from 'yup';
import { HomeFilterData } from '../../../dto/home/home-filter-data';
import { Segment, compareSegmentWith} from '../../../dto/segment';
import { Store, compareStoreWith } from '../../../dto/store/store';
import HomeContext from '../context';
import { findAllSegment, findAllStores } from './service';

const Filter: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [allStores, setAllStores] = useState([] as Store[])
  const [allSegments, setAllSegments] = useState([] as Segment[])
  const formRef = useRef({} as any)
  const { dataHome, setDataHome } = useContext(HomeContext);

  useEffect(() => {
    if (open) {
      const find = async () => {
        const allStores = await findAllStores()
        setAllStores(allStores)
        
        const allSegments = await findAllSegment()
        setAllSegments(allSegments)
      }
      find()
    }
  }, [open])

  const closeModal = () => {
    setOpen(false);
  }

  const submit = async (values: HomeFilterData) => {
    closeModal()
    setDataHome({
      filter: values
    })
  }

  const applyFilter = () => {
    if (formRef.current) {
      formRef.current.handleSubmit()
    }
  }

  return (
    <>
      <IonButton color="light" onClick={() => setOpen(true)} >
        <IonIcon icon={optionsOutline} />
      </IonButton>

      <IonModal
        isOpen={open}
        onDidDismiss={closeModal}
        breakpoints={[0, 0.2, 0.5, 0.8, 1]}
        initialBreakpoint={0.5}
        backdropBreakpoint={0.2}
      >
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonButton color="light" onClick={() => setOpen(false)}>Cancelar</IonButton>
            </IonButtons>

            <IonTitle style={{ textAlign: 'center' }}>Filtro</IonTitle>

            <IonButtons slot="end">
              <IonButton color="light" strong={true} onClick={() => applyFilter()}>Aplicar</IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>

        <IonContent>

          {/* Formulário de filtro */}
          <Formik
            innerRef={formRef}
            initialValues={dataHome.filter}
            onSubmit={submit}
            validationSchema={
              Yup.object().shape({
                date: Yup.date().required(),
                stores: Yup.array(),
                segments: Yup.array(),
              })
            }
          >
            {(propsForm) => (
              <Form id='my-form'>
                <IonList>
                  <IonItem>
                    <IonLabel>Início :</IonLabel>
                    <IonDatetimeButton datetime="datetimeStart" />
                    <IonModal keepContentsMounted={true} >
                      <IonDatetime
                        id="datetimeStart"
                        name="date"
                        onIonChange={propsForm.handleChange}
                        onIonBlur={propsForm.handleBlur}
                        value={propsForm.values.date}
                        locale="pt-BR"
                        presentation={'date'}
                        showDefaultButtons={true}
                        style={{ width: '100%' }}
                      />
                    </IonModal>
                  </IonItem>

                  <IonItem>
                    <IonLabel>Segmentos</IonLabel>
                    <IonSelect
                      value={propsForm.values.segments}
                      placeholder="Segmentos "
                      name='segments'
                      compareWith={compareSegmentWith}
                      onIonChange={propsForm.handleChange}
                      onIonBlur={propsForm.handleBlur}
                      multiple={true}
                    >
                      {allSegments.map((segment) => (
                        <IonSelectOption key={segment.id} value={segment}>
                          {segment.name}
                        </IonSelectOption>
                      ))}
                    </IonSelect>
                  </IonItem>

                  <IonToolbar className='filter-white'>
                    <IonButtons  className='filter-white' slot="end" style={{ marginRight: '2em' }}>
                      <IonButton onClick={() => { propsForm.setFieldValue('segments', []) }} >
                        <IonIcon icon={squareOutline} />
                      </IonButton>
                      <IonButton onClick={() => { propsForm.setFieldValue('segments', allSegments) }} >
                        <IonIcon icon={checkmarkDoneOutline} />
                      </IonButton>
                    </IonButtons>
                  </IonToolbar>

                  <IonItem>
                    <IonLabel>Unidades</IonLabel>
                    <IonSelect
                      value={propsForm.values.stores}
                      placeholder="Todas as lojas"
                      name='stores'
                      compareWith={compareStoreWith}
                      onIonChange={propsForm.handleChange}
                      onIonBlur={propsForm.handleBlur}
                      multiple={true}
                    >
                      {allStores.map((store) => (
                        <IonSelectOption key={store.id} value={store}>
                          {store.name}
                        </IonSelectOption>
                      ))}
                    </IonSelect>
                  </IonItem>

                  <IonToolbar className='filter-white'>
                    <IonButtons slot="end" style={{ marginRight: '2em' }}>
                      <IonButton onClick={() => { propsForm.setFieldValue('stores', []) }} >
                        <IonIcon icon={squareOutline} />
                      </IonButton>
                      <IonButton onClick={() => { propsForm.setFieldValue('stores', allStores) }} >
                        <IonIcon icon={checkmarkDoneOutline} />
                      </IonButton>
                    </IonButtons>
                  </IonToolbar>
                </IonList>
              </Form>
            )}
          </Formik>
        </IonContent>
      </IonModal>
    </>
  );
};

export default Filter;